export interface SdkConfig {
  merchantId: string;
  host: string;
}

let _config: SdkConfig | null = null;

function normalizeHost(host: string): string {
  return host.replace(/\/+$/, '');
}

export function initConfig(cfg: SdkConfig): void {
  if (!cfg || typeof cfg.merchantId !== 'string' || !cfg.merchantId) {
    throw new Error('gokwik.init: merchantId is required (non-empty string)');
  }
  if (typeof cfg.host !== 'string' || !cfg.host) {
    throw new Error('gokwik.init: host is required (non-empty string)');
  }
  const normalizedHost = normalizeHost(cfg.host);
  if (!normalizedHost) {
    throw new Error(`gokwik.init: host="${cfg.host}" normalizes to empty string`);
  }
  const normalized: SdkConfig = {
    merchantId: cfg.merchantId,
    host: normalizedHost,
  };
  if (_config) {
    if (_config.merchantId === normalized.merchantId && _config.host === normalized.host) {
      return;
    }
    throw new Error(
      `gokwik.init already called with merchantId="${_config.merchantId}" host="${_config.host}"; ` +
        `cannot re-init with merchantId="${normalized.merchantId}" host="${normalized.host}"`,
    );
  }
  _config = normalized;
}

export function getConfig(): SdkConfig {
  if (!_config) {
    throw new Error('gokwik.init({ merchantId, host }) must be called before any SDK function');
  }
  return _config;
}

export function isInitialized(): boolean {
  return _config !== null;
}

export function __resetConfigForTests(): void {
  _config = null;
}
